import { rgba } from "polished";
import styled, { css } from "styled-components";
import Icon from "../../../../../../base/icons/icon/index.js";
import { FontMixin } from "../../../../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius, Padding } from "../../../../../../../styles/common/mixins/logical.styled.js";
import headerBadgesThemes from "./themes/index.js";
const variantStylesIconBadgeDesktop = (variant = '', modifier = 'DEFAULT')=>({
        DISNEY: ({
            DEALS: css`
				background-color: var(--icon-badge-disney-bg);
			`,
            BLACKFRIDAY: css`
				background-color: var(--icon-badge-disney-bg);
			`,
            DEFAULT: css`
				background-color: var(--icon-badge-disney-bg);
			`
        })[modifier]
    })[variant.toUpperCase()] ?? ({
        DEALS: css`
			background-color: var(--icon-badge-is-deal-bg);
		`,
        BLACKFRIDAY: css`
			background-color: var(--icon-badge-is-black-friday-bg);
		`,
        DEFAULT: css`
			background-color: var(--icon-badge-bg);
		`
    })[modifier];
export const IconBadgeDesktop = styled.div.withConfig({
    displayName: "styled__IconBadgeDesktop",
    componentId: "sc-d196f7d0-0"
})`
	--icon-badge-bg: ${({ theme  })=>theme.colors.primary.base};
	--icon-badge-is-deal-bg: ${({ theme  })=>rgba(theme.colors.status.offer, 0.9)};
	--icon-badge-is-black-friday-bg: ${({ theme  })=>theme.colors.black.base};
	--icon-badge-disney-bg: ${({ theme  })=>rgba(theme.colors.status.offer, 0.9)};

	${({ $variant  })=>variantStylesIconBadgeDesktop($variant)}
	${BorderRadius({
    all: '4px'
})}
	color: ${({ theme  })=>theme.colors.white.base};
	min-height: 32px;
	min-width: 32px;
	${Padding({
    all: '8px'
})}
	position: absolute;
	right: 8px;
	top: 8px;
	z-index: ${({ theme  })=>theme.zIndex.lowest};

	${Icon} {
		${FontMixin({
    size: 'larger',
    height: 'large',
    weight: 'regular'
})}
	}

	&.is-deal {
		${({ $variant  })=>variantStylesIconBadgeDesktop($variant, 'DEALS')}
	}

	&.is-blackfriday {
		${({ $variant  })=>variantStylesIconBadgeDesktop($variant, 'BLACKFRIDAY')}
	}

	& .discount {
		${FontMixin({
    size: 'larger',
    height: 'base',
    weight: 'regular'
})}

		&::before {
			content: '-';
		}
		&::after {
			content: '%';
		}
	}

	${({ theme  })=>theme.media.down('tablet')} {
		&:has(> .discount) {
			&.is-deal {
				min-height: unset;
				min-width: unset;
				${Padding({
    y: '2px',
    x: '6px'
})}
				background-color: ${({ theme  })=>theme.colors.status.offer};
			}
		}

		& .discount {
			font-size: 20px;
			line-height: 22px;
		}
	}
`;
export const TagBadge = styled.div.withConfig({
    displayName: "styled__TagBadge",
    componentId: "sc-d196f7d0-1"
})`
	background-color: ${({ theme  })=>theme.colors.status.success};
	${BorderRadius({
    all: '4px'
})}
	color: ${({ theme  })=>theme.colors.white.base};
	${FontMixin({
    size: 'small',
    weight: 'medium',
    height: 'smaller'
})}
	left: 8px;
	max-width: 170px;

	${Padding({
    y: '4px',
    x: '8px'
})}
	position: absolute;
	text-transform: uppercase;
	top: 8px;
	z-index: ${({ theme  })=>theme.zIndex.lowest};

	${({ theme  })=>theme.media.down('tablet')} {
		line-height: 18px;
	}

	${({ theme  })=>headerBadgesThemes[theme.id]?.TagBadge?.()}
`;

//# sourceMappingURL=styled.js.map